import React from 'react';
import pluralize from 'pluralize';

import { getCurrentPage } from '../helpers';

interface PaginationHeaderProps {
  text: string;
  total: number;
  perPage?: number;
};

const PaginationHeader: React.FC<PaginationHeaderProps> = ({ text, total, perPage = 12 }) => {
  if (total === 0) {
    return null;
  }

  let pagination = '';
  if (total > perPage) {
    const page = getCurrentPage();
    pagination = `${(page - 1) * perPage + 1} - ${Math.min(page * perPage, total)} of `
  }

  return (
    <div className="pagination-header">
      {pagination}{pluralize(text, total, true)}
    </div>
  );
}

export default PaginationHeader;
